if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.form = Array.from(this.querySelectorAll('form[action="/cart/add"]'))
        .find(f => f.querySelector('[name="add"]'))
        || this.querySelector('form[action="/cart/add"]');

      if (this.form) {
        const idInput = this.form.querySelector('[name="id"]');
        if (idInput) idInput.disabled = false;

        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.submitBtn = this.querySelector('[name="add"]');
          if (this.submitBtn) {
            this.submitBtn.addEventListener('click', this.handleSubmit.bind(this), true);
          }
        }
      }
    }

    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;
      // BSS button already handling — skip
      // if (document.querySelector('[po-btn-atc="true"]')) return;
      evt.stopImmediatePropagation();
      evt.preventDefault();
   
      if (!this.form) this.init();
      if (!this.form) return;

      const idInput = this.form.querySelector('[name="id"]');
      const variantId = idInput && idInput.value ? idInput.value.trim() : '';
      if (!variantId) return;

      if (this.submitBtn?.getAttribute('aria-disabled') === 'true') return;

      this.submitBtn?.setAttribute('aria-disabled', 'true');
      this.submitBtn?.classList.add('is-loading');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(this.form)
        });

        if (!res.ok) throw new Error('Cart add failed');
        await res.json();
           //debugger;
        if (this.cartDrawer) {
          if (typeof this.cartDrawer.open === 'function') this.cartDrawer.open();
          if (typeof this.cartDrawer.refresh === 'function') {
            await this.cartDrawer.refresh();
          } else {
            const cartItems = document.querySelector('cart-items');
            if (cartItems && typeof cartItems.refresh === 'function') cartItems.refresh();
          }
        } else {
          window.location.href = '/cart';
        }

      } catch (e) {
        console.log('ATC error:', e);
        if (e.message !== 'Invalid body') {
          window.location.href = '/cart';
        }
      } finally {
        this.submitBtn?.classList.remove('is-loading');
        this.submitBtn?.removeAttribute('aria-disabled');
      }
    }

    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      const html = response?.sections?.['cart-icon-bubble'];
      if (cartIconBubble && html) {
        cartIconBubble.innerHTML = html;
      }
    }

    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}